import React from 'react'
import { ChartSkeletonBase } from './ChartSkeletonBase'

export const BarChartSkeleton: React.FC<{
  loading?: boolean
  progress?: number
  height?: number
  progressDetails?: React.ReactElement
  showLoadingPercent?: boolean
  hideLoadingSpinner?: boolean
}> = props => {
  return <ChartSkeletonBase {...props} getBarHeight={index => Math.cos(index - 1) * 150} />
}
